import { Pipe } from "@angular/core";
import { areStringsEqual, isStringNullOrEmpty } from "@globals/helper-functions";
import { TranslatePipe } from "@ngx-translate/core";

@Pipe({
  name: "translate",
  pure: false
})
export class BiTranslatePipe extends TranslatePipe {
  override transform(key: string, params?: { [key: string]: string | number }): string {
    const translatedValue = !isStringNullOrEmpty(key) ? super.transform(key.toUpperCase(), params) : "";

    return areStringsEqual(key, translatedValue) ? key : translatedValue;
  }
}
